import { Canvas } from 'fabric';

import { Tool } from '../draw-canvas.constants';
import IconText from 'approot/shared/inline-svg/activity-builder/icon-text';
import { ToolBarTool } from './toolbar.style';
import { useDrawCanvasContext } from '../draw-canvas.context';
import ToolbarItem from './toolbar-item';

type Props = {
  canvas?: Canvas | null;
};

const ToolbarItemText = ({ canvas }: Props) => {
  const { toolSet, setToolSet, turnOffDrawMode } = useDrawCanvasContext();

  return (
    <ToolbarItem hoverText="Text">
      <ToolBarTool
        $isActive={toolSet?.tool === Tool.Text}
        onClick={() => {
          if (canvas) {
            canvas.discardActiveObject();
            canvas.renderAll();
            turnOffDrawMode(canvas);
            setToolSet({ tool: Tool.Text });
          }
        }}
      >
        <IconText width={24} height={24} />
      </ToolBarTool>
    </ToolbarItem>
  );
};

export default ToolbarItemText;
